<template>
  <div class="w-full flex py-1 justify-between font-bold text-EXPONDO-grey">
    <div class="min-w-[50px] text-center">
      {{ volumeDiscount.volume }}+
    </div>
    <div
      class="min-w-[50px] text-center"
      :class="{'text-EXPONDO-red': effectiveDiscountPercentage() > 0}"
    >
      {{ effectiveDiscountPercentage() }}%
    </div>
    <div
      class="min-w-[120px] text-center"
    >
      {{ formatCurrency(getDiscountedByVolume()) }}
    </div>
  </div>
</template>

<script lang="ts">

import type { VolumeDiscount } from '~~/types/discounts';

export default defineComponent({
  name: 'VolumeDiscountRow',
  props: {
    volumeDiscount: {
      type: Object as PropType<VolumeDiscount>,
      required: true,
    },
    finalPrice: {
      type: Number,
      required: true,
    },
    loyaltyDiscountPercentage: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {

    const { formatCurrency } = useFormatCurrency();

    const { volumeDiscount, finalPrice, loyaltyDiscountPercentage } = toRefs(props);

    const getDiscountedByVolume = (): number => {

      if (volumeDiscount.value.volume === 1) {

        return finalPrice.value;

      }

      const afterVolumeDiscount = finalPrice.value - (finalPrice.value / 100 * volumeDiscount.value.discountPercentage);

      if (loyaltyDiscountPercentage.value > 0) {

        return afterVolumeDiscount - (afterVolumeDiscount / 100 * loyaltyDiscountPercentage.value);

      }

      return afterVolumeDiscount;

    };

    const effectiveDiscountPercentage = (): number => {

      if (loyaltyDiscountPercentage.value > 0 && volumeDiscount.value.volume !== 1) {

        const volumeDiscountPercentage = volumeDiscount.value.discountPercentage;
        const loyaltyPercentage = loyaltyDiscountPercentage.value;

        return volumeDiscountPercentage + loyaltyPercentage
         - (volumeDiscountPercentage * loyaltyPercentage / 100);

      }

      return volumeDiscount.value.discountPercentage;

    };

    return {
      formatCurrency,
      getDiscountedByVolume,
      effectiveDiscountPercentage,
    };

  },
});


</script>
